// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/alr-schema',
  type: 'object',
  required: [],
  properties: {
    pro: {
      type: 'string',
      nullable: true,
    },
    ver: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
